import "../App.css";
import StatusSaverIcon from "../Images/StatusSaverAppIcon.png";
import MathFormulaAppIcon from "../Images/MathFormulaAppIcon.png";
import GroceryTrackerIcon from "../Images/GroceryTrackerAppIcon.png";
import ResumebuilderIcon from "../Images/resumebuilder.png";
const AllApps = () => {
  return (
    <section id="apps" className="apps">
      <div className="container">
        <h2 className="section-title">Our Applications</h2>

        {/* Status Saver App Card */}
        <div className="app-card">
          <div className="app-icon">
            <img src={StatusSaverIcon} alt="Status Saver App" />
          </div>
          <div className="app-details">
            <h3 className="app-title">Status Downloader- Save Status</h3>
            <p className="app-description">
              The ultimate solution for managing and saving your favorite status
              updates from WhatsApp with ease and convenience.
            </p>

            <div className="features">
              <h3>Key Features</h3>
              <ul className="feature-list">
                <li>
                  <i className="fas fa-check-circle"></i> View previously seen
                  WhatsApp statuses
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> Download statuses
                  directly to your device
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> Share statuses across
                  multiple platforms
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> Add favorite statuses
                  to your collection
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> Send messages without
                  saving numbers
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> User-friendly and
                  intuitive interface
                </li>
              </ul>
            </div>

            <div className="keywords">
              <h3>Keywords</h3>
              <div className="keyword-tags">
                <span>WhatsApp Status Saver</span>
                <span>Status Downloader</span>
                <span>Media Saver</span>
                <span>Status Manager</span>
                <span>WhatsApp Tools</span>
              </div>
            </div>

            <div className="app-buttons">
              <a href="/" className="btn">
                Download App
              </a>
              <a href="/StatusSaverPrivacyPolicy" className="btn btn-secondary">
                Privacy Policy
              </a>
            </div>
          </div>
        </div>

        {/* Math Formula App Card */}
        <div className="app-card">
          <div className="app-icon">
            <img src={MathFormulaAppIcon} alt="Math Formula App" />
          </div>
          <div className="app-details">
            <h3 className="app-title">Math Formula - Let's Solve It</h3>
            <p className="app-description">
              A comprehensive app for students and enthusiasts to explore math
              formulas, tricks, quizzes, calculators, and educational games.
            </p>

            <div className="features">
              <h3>Key Features</h3>
              <ul className="feature-list">
                <li>
                  <i className="fas fa-check-circle"></i> Explore a wide range
                  of math formulas
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> Learn math tricks to
                  solve problems faster
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> Practice quizzes to
                  test your knowledge
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> Built-in calculators
                  for quick computations
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> Fun math games to
                  enhance learning
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> User-friendly and
                  intuitive interface
                </li>
              </ul>
            </div>

            <div className="keywords">
              <h3>Keywords</h3>
              <div className="keyword-tags">
                <span>Math Formula App</span>
                <span>Math Tricks</span>
                <span>Math Quiz</span>
                <span>Calculator</span>
                <span>Educational Games</span>
              </div>
            </div>

            <div className="app-buttons">
              <a href="/" className="btn">
                Download App
              </a>
              <a href="/MathFormulaPrivacyPolicy" className="btn btn-secondary">
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
        {/* Grocery Expenses Tracker Card */}
        <div className="app-card">
          <div className="app-icon">
            <img src={GroceryTrackerIcon} alt="Grocery Tracker App" />
          </div>
          <div className="app-details">
            <h3 className="app-title">Grocery Expenses Tracker</h3>
            <p className="app-description">
              Easily manage your grocery shopping, track expenses, and stay on
              budget with this simple and intuitive grocery tracker app.
            </p>

            <div className="features">
              <h3>Key Features</h3>
              <ul className="feature-list">
                <li>
                  <i className="fas fa-check-circle"></i> Track daily and
                  monthly grocery expenses
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> Create and manage
                  smart shopping lists
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> Set grocery budgets
                  and get spending insights
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> Visualize expenses
                  with charts and reports
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> Offline support for
                  anytime access
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> Upcoming features:
                  Export statistics, monthly grocery list, reminders
                </li>
              </ul>
            </div>

            <div className="keywords">
              <h3>Keywords</h3>
              <div className="keyword-tags">
                <span>Grocery Tracker</span>
                <span>Expense Manager</span>
                <span>Shopping List App</span>
                <span>Budget Planner</span>
                <span>Money Saver</span>
              </div>
            </div>

            <div className="app-buttons">
              <a href="/" className="btn">
                Download App
              </a>
              <a
                href="/GroceryTrackerPrivacyPolicy"
                className="btn btn-secondary"
              >
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
        {/* Resume Builder App Card */}
        <div className="app-card">
          <div className="app-icon">
            <img src={ResumebuilderIcon} alt="Resume Builder App" />
          </div>

          <div className="app-details">
            <h3 className="app-title">Resume Builder </h3>

            <p className="app-description">
              Create professional, ATS-friendly resumes in minutes. Choose from
              modern templates, enter your details, and export high-quality
              resumes as PDF with ease.
            </p>

            <div className="features">
              <h3>Key Features</h3>
              <ul className="feature-list">
                <li>
                  <i className="fas fa-check-circle"></i> Multiple modern &
                  professional resume templates
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> Step-by-step resume
                  builder for freshers & professionals
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> ATS-friendly resume
                  formats
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> Export resume as
                  high-quality PDF
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> Edit, update, and
                  reuse resumes anytime
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> Upcoming features:
                  Cover letter builder, multiple languages, cloud backup
                </li>
              </ul>
            </div>

            <div className="keywords">
              <h3>Keywords</h3>
              <div className="keyword-tags">
                <span>Resume Builder</span>
                <span>CV Maker</span>
                <span>ATS Resume</span>
                <span>Job Resume App</span>
                <span>PDF Resume</span>
              </div>
            </div>

            <div className="app-buttons">
              <a href="/" className="btn">
                Download App
              </a>
              <a
                href="/ResumeBuilderPrivacyPolicy"
                className="btn btn-secondary"
              >
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default AllApps;
